import { render, staticRenderFns } from "./WhatsappAppearance.vue?vue&type=template&id=18e07e9c&"
import script from "./WhatsappAppearance.vue?vue&type=script&lang=js&"
export * from "./WhatsappAppearance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports